import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Switch } from "@/components/ui/switch";
import { FiMoon, FiSun } from "react-icons/fi";
import { GroupTheme } from "../types/global";
export function SetThemeWithLocalStorage(theme) {
    localStorage.theme = theme;
    if (document.documentElement.classList.contains("dark") &&
        localStorage.theme != GroupTheme.Dark) {
        document.documentElement.classList.remove("dark");
    }
    else {
        document.documentElement.classList.add("dark");
    }
}
export function SetTheme(theme) {
    if (document.documentElement.classList.contains("dark") &&
        theme != GroupTheme.Dark) {
        document.documentElement.classList.remove("dark");
    }
    else {
        document.documentElement.classList.add("dark");
    }
}
export function GetTheme() {
    const theme = localStorage.getItem("theme");
    if (theme !== null) {
        return localStorage.theme == GroupTheme.Dark
            ? GroupTheme.Dark
            : GroupTheme.Light;
    }
    else {
        return null;
    }
}
export function GetAppliedTheme() {
    return document.documentElement.classList.contains("dark")
        ? GroupTheme.Dark
        : GroupTheme.Light;
}
// ! Pulsante non in giusta posizione all'avvio della finestra
export function ThemeButton() {
    const { t } = useTranslation();
    const [darkMode, setDarkMode] = React.useState(GetAppliedTheme());
    function set() {
        const newTheme = darkMode === GroupTheme.Dark ? GroupTheme.Light : GroupTheme.Dark;
        SetThemeWithLocalStorage(newTheme);
        setDarkMode(newTheme);
    }
    return (_jsxs("div", { className: "m-1 flex items-center rounded-md px-4 py-2 select-none", children: [darkMode === GroupTheme.Dark ? (_jsx(FiMoon, { className: "mr-2" })) : (_jsx(FiSun, { className: "mr-2" })), _jsx("span", { className: "text-generic", children: t("change-theme") }), _jsx(Switch, { className: "ml-auto cursor-pointer", onClick: set, checked: darkMode === GroupTheme.Dark })] }));
}
